/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { DateOfBirthRequestPayloadSideEffectType } from "./DateOfBirthRequestPayloadSideEffectType";

export interface DateOfBirthRequestPayload {
  side_effect_type: DateOfBirthRequestPayloadSideEffectType;
  conversation_id: string;
}
